import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import { RegistrationType } from '../Store/Types';

interface Props {
  registrationType: RegistrationType;
}

const RegistrationLabel: React.FC<Props> = ({ registrationType }) => {
  switch (registrationType) {
    case 'student':
      return <></>;
    case 'auditor':
      return (
        <div className=" ml-5 flex cursor-pointer">
          <div className="mr-2 flex items-center rounded-2xl border-teal-600 text-teal-600 px-3 py-1 text-xs border">
            <span>
              <T kind="Auditor" />
            </span>
          </div>
        </div>
      );
  }
};
export default observer(RegistrationLabel);
